import type { IDBPDatabase } from 'idb';

import type { MyDB } from './openIDB';

export async function* iterateKeys(
  db: IDBPDatabase<MyDB>,
  formDataId: number,
  batchSize = 200,
): AsyncGenerator<number[]> {
  let lastPK: number | undefined = undefined;

  while (true) {
    const tx = db.transaction('landmarks', 'readonly');
    const index = tx.objectStore('landmarks').index('by-formDataId');
    const keys: number[] = [];

    for (
      let c = await index.openKeyCursor(IDBKeyRange.only(formDataId));
      c;
      c = await c.continue()
    ) {
      const pk = c.primaryKey as number;
      if (lastPK !== undefined && pk <= lastPK) continue;
      keys.push(pk);
      if (keys.length === batchSize) break;
    }
    await tx.done;

    if (keys.length === 0) break;
    lastPK = keys[keys.length - 1];
    yield keys;
  }
}
